import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  Radio,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  IconButton,
  useTheme,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../../user-redux/selector";
import Key from "../../../../clientVariables.json";
import {
  getCandidateDocuments,
  getSubmissionResumeDetails,
  updateSubmissionsAction,
} from "../../redux/action";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import moment from "moment";
import pdfImg from "../../../images/pdfimg2.png";
import { Visibility } from "@mui/icons-material";
import SignatureEditor from "../../../SignatureEditor";
import ReactQuill from "react-quill"; // Primary editor for email body
import "react-quill/dist/quill.snow.css";
import { DataGrid } from "@mui/x-data-grid";
import { myCandidatesSelector } from "../../redux/selector";
import { useRef } from "react";

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "name",
    headerName: "Document Name",
    width: 200,
    renderCell: (params) => (
      <span>{params.value.replace(/^(CAND_)+/i, "")}</span>
    ),
  },
  { field: "size", headerName: "Size", width: 120 },
  { field: "created", headerName: "Created", width: 180 },
];

const Step3 = ({
  step3EmailDataHandler,
  sharedData,
  hideToEmail = false,
}) => {


  const dispatch = useDispatch();

  const {
    candidateResumesList,
    candidateDetails,
    selectedSubmission,
    candidateDocuments,
    submissionSelectedResume,
  } = useSelector(myCandidatesSelector);

  const { user } = useSelector(userSelector);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openSuccessToast, setOpenSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [resumes, setResumes] = useState([]);
  const [selectedResume, setSelectedResume] = useState(null);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [resumeId, setResumeId] = useState("");
  const [primaryResumeId, setPrimaryResumeId] = useState("");
  const [resumeDetails, setResumeDetails] = useState("")
  const [changeToEmail, setChangeToEmail] = useState(false);
  const [showCC, setShowCC] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [editMode, setEditMode] = useState("default");
  const [openSignatureDialog, setOpenSignatureDialog] = useState(false);
  const [signatureName, setSignatureName] = useState("");
  const [signatureHtml, setSignatureHtml] = useState("");
  const [isSavingSignature, setIsSavingSignature] = useState(false);
  const [savedSignatures, setSavedSignatures] = useState([]);
  const [selectedSignatureId, setSelectedSignatureId] = useState("");
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");

  const generateFullEmailContent = (data) => {
    if (!data) return "";
    return `
      ${data.vendorName && data.vendorName !== "N/A" ? `<p>Dear ${data.vendorName},</p>` : `<p>Dear,</p>`}
      <p>I hope this email finds you well.</p>
      <p>I am writing to submit the profile of <strong>${data.candidateName}</strong> for the <strong>${selectedSubmission?.jobtitle || "position"}</strong>. Below are the key details and professional summary of the candidate for your review:</p>
      
      <div class="candidate-info">
        <h3 class="section-title">Candidate Professional Details</h3>
        <div class="info-row"><span class="info-label">Full Name:</span><span class="info-value">${data.candidateName}</span></div>
        <div class="info-row"><span class="info-label">Location:</span><span class="info-value">${data.candidateLocation}</span></div>
        <div class="info-row"><span class="info-label">Contact Number:</span><span class="info-value">${data.candidateContactNumber}</span></div>
        <div class="info-row"><span class="info-label">Email Address:</span><span class="info-value">${data.candidateEmail}</span></div>
        <div class="info-row"><span class="info-label">Visa Status:</span><span class="info-value">${data.candidateVisaStatus}</span></div>
        <div class="info-row"><span class="info-label">LinkedIn Profile:</span><span class="info-value">${data.candidateLinkedin}</span></div>
        <div class="info-row"><span class="info-label">Education:</span><span class="info-value">${data.candidateEducation}</span></div>
        <div class="info-row"><span class="info-label">Total Experience:</span><span class="info-value">${data.total_experience}</span></div>
      </div>

      <div class="candidate-info">
        <h3 class="section-title">Availability and Logistics</h3>
        <div class="info-row"><span class="info-label">Availability:</span><span class="info-value">${data.candidateAvailability}</span></div>
        <div class="info-row"><span class="info-label">Current Status:</span><span class="info-value">${data.candidateCurrentlyOnProject}</span></div>
        <div class="info-row"><span class="info-label">Relocation:</span><span class="info-value">${data.candidateRelocationConfirmation}</span></div>
        <div class="info-row"><span class="info-label">Hourly Rate:</span><span class="info-value">${data.candidateRate}</span></div>
        <div class="info-row"><span class="info-label">Last 4 Digits of SSN:</span><span class="info-value">${data.ssnLast4Digits}</span></div>
      </div>

      ${data.candidateCertifications ? `
      <div class="candidate-info">
        <h3 class="section-title">Certifications</h3>
        <div class="info-row"><span class="info-value">${data.candidateCertifications}</span></div>
      </div>` : ''}

      <p>I have attached the candidate's resume for a more detailed overview of their technical expertise and project history.</p>
    `;
  };

  const [formData, setFormData] = useState({
    toEmail:
      selectedSubmission?.email_id !== undefined &&
        selectedSubmission.email_id !== null
        ? selectedSubmission.email_id
        : "",
    ccEmail: "", // Add this line
    subject:
      `${candidateDetails?.candidate_name} for ${selectedSubmission?.jobtitle}` ||
      "",
    attachmentName: selectedSubmission?.filename || "",
    candidateid: selectedSubmission?.candidate_id || "",
    emailBody: "",
    fromEmail: user?.username || "",
    jobid: selectedSubmission?.job_id || "",
    userid: user?.id || "",
    resumeid:
      submissionSelectedResume?.resume_id ||
      selectedSubmission?.resume_id ||
      primaryResumeId,
    vendorName: selectedSubmission?.contact_name || "",
    candidateName: candidateDetails?.candidate_name || "",
    candidateLocation:
      candidateDetails?.city_name && candidateDetails?.state_name
        ? `${candidateDetails?.city_name || ""}, ${candidateDetails?.state_name || ""
        }, ${candidateDetails?.country_name}`
        : "",
    candidateContactNumber: resumeDetails?.resumedetails?.home_phone || "",
    candidateEmail: resumeDetails?.email || "",
    candidateVisaStatus: resumeDetails?.visatype || "",
    candidateLinkedin: resumeDetails?.linkedin_url || "",
    candidateEducation: resumeDetails?.educationdetails || "",
    candidateAvailability: resumeDetails?.availability_for_project || "",
    candidateVedioInterviewAvailbility: "",
    candidateCurrentlyOnProject: resumeDetails?.currently_on_project || "",
    candidateCertifications: resumeDetails?.certificatedetails || "",
    candidateRelocationConfirmation:
      resumeDetails?.willing_to_relocate || "",
    total_experience: resumeDetails?.resumedetails?.total_experience || "",
    candidateRate: "",
    ssnLast4Digits: 2222,
    attachment_ids: [],
    customMode: false,
    selectedSignatureHtml: "",
  });

  const isDataPopulated = useRef(false);

  // Reset population lock when selected submission changes
  useEffect(() => {
    isDataPopulated.current = false;
  }, [selectedSubmission?.id]);

  const handleEditModeChange = (mode) => {
    setEditMode(mode);
    setFormData(prev => {
      const updated = {
        ...prev,
        customMode: mode === 'custom',
        emailBody: mode === 'default' ? generateFullEmailContent(prev) : prev.emailBody
      };
      step3EmailDataHandler(updated);
      return updated;
    });
  };

  // useEffect(() => {
  //   console.log("resumeDetails-------", resumeDetails);
  //   console.log("selected data---", selectedSubmission)
  //   console.log("selected data-------------------", candidateDetails)
  // },[resumeDetails])

  useEffect(() => {
    if (sharedData && sharedData.length > 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        toEmail: `${selectedSubmission?.email_id} ${sharedData
          .map((item) => item.EMP_CONTACT_EMAIL)
          .join(",")}`,
      }));
    }
  }, [sharedData]);

  const [errors, setErrors] = useState({
    attachmentName: "",
    toEmail: "",
    ccEmail: "",
    subject: "",
    emailBody: "",
  });

  const theme = useTheme();
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));

  const controlProps = (item) => ({
    checked:
      item?.resume_id ===
      (submissionSelectedResume?.resume_id || selectedSubmission?.resume_id || primaryResumeId),
    // onChange: () => handleFileChange(item),
    value: item?.resume_id,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item.resume_id },
    disabled:
      item?.resume_id !==
      (submissionSelectedResume?.resume_id || selectedSubmission?.resume_id || primaryResumeId),
  });

  const handleFileChange = (item) => {
    setSelectedResume(item);
    setFormData((prevFormData) => ({
      ...prevFormData,
      resumeid:
        submissionSelectedResume && submissionSelectedResume.resume_id !== 0
          ? submissionSelectedResume.resume_id
          : primaryResumeId,
    }));
  };
  useEffect(() => {
    getResumes();
  }, []);

  // Add this effect to send updated formData to parent only when ready
  useEffect(() => {
    if (
      formData.candidateName &&
      formData.candidateEmail
    ) {
      step3EmailDataHandler(formData);
    }
  }, [formData, step3EmailDataHandler]);

  useEffect(() => {
    var storedData = sessionStorage.getItem("data");
    //console.log(storedData);
  }, [sessionStorage]);


  const fetchPrimaryResume = useCallback(async () => {
    try {
      if (candidateDetails?.candidate_id) {
        const primaryResponse = await axios.post(
          `${Key.domain}/candidate/get_primary_resume_details`,
          { candidate_id: candidateDetails.candidate_id }
        );
        setPrimaryResumeId(primaryResponse.data.data[0].id);
        return primaryResponse.data.data[0].id; // Return the ID for chaining
      }
    } catch (error) {
      console.error("Error fetching primary resume:", error);
    }
  }, [candidateDetails?.candidate_id]);

  const selectedId = submissionSelectedResume?.resume_id || selectedSubmission?.resume_id || primaryResumeId;

  // 2. Fetch resume details only after primaryResumeId is set
  const fetchResumeDetails = useCallback(async (resumeId) => {
    try {
      if (resumeId) {
        const response = await axios.post(
          `${Key.domain}/candidate/get_js_profile_details`,
          { resume_id: resumeId }
        );
        setResumeDetails(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching resume details:", error);
    }
  }, []);

  // 3. Combined effect to run in sequence
  useEffect(() => {
    const fetchData = async () => {
      const primaryResId = await fetchPrimaryResume(); // Wait for primary resume
      const targetResumeId = submissionSelectedResume?.resume_id || selectedSubmission?.resume_id || primaryResId;
      if (targetResumeId) {
        await fetchResumeDetails(targetResumeId); // Then fetch details
      }
    };
    fetchData();
  }, [fetchPrimaryResume, fetchResumeDetails, submissionSelectedResume?.resume_id, selectedSubmission?.resume_id]);

  // useEffect(() => {
  //   console.log("selectedSubmission?.id", selectedSubmission?.id);
  //   console.log("candidateDetails?.candidate_id", candidateDetails?.candidate_id);
  //   console.log("resumeDetails", resumeDetails);
  //   console.log("isDataPopulated.current", isDataPopulated.current);
  // }, [selectedSubmission?.id, candidateDetails?.candidate_id, resumeDetails, isDataPopulated.current]);

  useEffect(() => {
    if (selectedSubmission?.id && candidateDetails?.candidate_id && resumeDetails && !isDataPopulated.current) {
      //console.log("data in submission page", selectedSubmission);
      const savedDataStr = sessionStorage.getItem("saved_step3_data");
      if (savedDataStr) {
        try {
          const parsed = JSON.parse(savedDataStr);
          if (
            String(parsed.candidateid) === String(selectedSubmission.candidate_id) &&
            String(parsed.jobid) === String(selectedSubmission.job_id)
          ) {
            // If emailBody was empty when saved, generate it now with resume data available
            if (!parsed.emailBody || parsed.emailBody.trim() === "") {
              parsed.emailBody = generateFullEmailContent(parsed);
            }
            setFormData(parsed);
            step3EmailDataHandler(parsed);
            isDataPopulated.current = true;
            sessionStorage.removeItem("saved_step3_data");
            return;
          }
        } catch (e) {
          console.error("Error parsing saved step3 data", e);
        }
        // Clean up only if candidateid/jobid don't match (different submission)
        sessionStorage.removeItem("saved_step3_data");
      }

      const educationDetails = resumeDetails?.educationdetails || [];
      const educationCourses = educationDetails.map(item => item.edu_course).filter(Boolean);
      const certificationDetails = resumeDetails?.certificatedetails || []
      const certificationName = certificationDetails.map(item => item.cer_name)

      const nextData = {
        ...formData,
        toEmail: selectedSubmission?.email_id || "",
        subject: `${candidateDetails?.candidate_name} for ${selectedSubmission?.jobtitle}` || "",
        attachmentName: selectedSubmission?.filename || "",
        candidateid: selectedSubmission?.candidate_id || "",
        fromEmail: user?.username || "",
        jobid: selectedSubmission?.job_id || "",
        userid: user?.id || "",
        resumeid: submissionSelectedResume?.resume_id || selectedSubmission?.resume_id || primaryResumeId,
        vendorName: selectedSubmission?.contact_name || "",
        candidateName: candidateDetails?.candidate_name || "",
        candidateLocation: [
          resumeDetails?.resumedetails?.cityname,
          resumeDetails?.resumedetails?.statename,
          resumeDetails?.resumedetails?.countryname
        ].filter(Boolean).join(", "),
        candidateContactNumber: resumeDetails?.resumedetails?.home_phone || "",
        candidateEmail: resumeDetails?.resumedetails?.email || "",
        candidateVisaStatus: resumeDetails?.resumedetails?.visatype_name || resumeDetails?.resumedetails?.visatype || "",
        candidateLinkedin: resumeDetails?.resumedetails?.linkedin_url || "",
        candidateEducation: educationCourses.join(", "),
        candidateAvailability: candidateDetails?.availability_for_project || "",
        candidateVedioInterviewAvailbility: "",
        candidateCurrentlyOnProject: candidateDetails?.currently_on_project || "",
        candidateCertifications: certificationName.join(", "),
        candidateRelocationConfirmation: resumeDetails?.resumedetails?.willing_to_relocate === 1 ? "Yes" : "No",
        total_experience: resumeDetails?.resumedetails?.total_experience || "",
        candidateRate: "",
        ssnLast4Digits: candidateDetails?.ssn || "",
        attachment_ids: [],
      };

      if (!nextData.emailBody) {
        nextData.emailBody = generateFullEmailContent(nextData);
      }

      setFormData(nextData);
      step3EmailDataHandler(nextData);
      isDataPopulated.current = true;
    }
  }, [selectedSubmission, candidateDetails, resumeDetails, primaryResumeId, submissionSelectedResume, user]);

  const fetchData = async () => {
    setIsLoading(true);
    const primaryResId = await fetchPrimaryResume();
    const targetResumeId = submissionSelectedResume?.resume_id || selectedSubmission?.resume_id || primaryResId;
    if (targetResumeId) {
      await fetchResumeDetails(targetResumeId);
    }
    setIsLoading(false);
  };

  // useEffect(() => {
  //   console.log("Resume Details Updated:", {
  //     home_phone: resumeDetails?.resumedetails?.home_phone,
  //     full_details: resumeDetails
  //   });
  // }, [resumeDetails]);

  // useEffect(() => {
  //   console.log("Form Data Updated:", selectedSubmission.resume_id);
  // }, [formData]);

  useEffect(() => {
    dispatch(
      getCandidateDocuments(
        candidateDetails?.candidate_id,
        candidateDetails?.user_id
      )
    );
  }, [dispatch]);



  useEffect(() => {
    getPrimaryResumeDetails();
  }, [candidateDetails]);

  const handleSuccessToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessToast(false);
  };

  const handleChange = (field) => (event) => {
    //console.log(`Changing ${field}: `, event.target.value);
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
    step3EmailDataHandler({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleQuillChange = (content) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      emailBody: content,
    }));
    step3EmailDataHandler((prevFormData) => ({
      ...prevFormData,
      emailBody: content,
    }));
  };

  const getResumes = async () => {
    try {
      if (candidateDetails?.candidate_id) {
        const response = await axios.post(
          `${Key.domain}/common/get_candidate_resumes_list`,
          { candidate_id: candidateDetails.candidate_id, user_id: user?.id }
        );
        setResumes(response.data.data);
        handleFileChange(response.data.data[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getPrimaryResumeDetails = async () => {
    try {
      if (candidateDetails?.candidate_id) {
        const response = await axios.post(
          `${Key.domain}/candidate/get_primary_resume_details`,
          { candidate_id: candidateDetails.candidate_id }
        );
        setPrimaryResumeId(response.data.data[0].id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSignatures = useCallback(async () => {
    try {
      if (user?.id) {
        const response = await axios.post(`${Key.domain}/user/get-employee-signature`, {
          user_id: user.id
        });
        if (response.data.success === 1) {
          // Based on your response structure, the array is in response.data.data.data
          const signatures = Array.isArray(response.data.data) ? response.data.data : (response.data.data?.data || []);
          setSavedSignatures(signatures);
        }
      }
    } catch (error) {
      console.error("Error fetching signatures:", error);
    }
  }, [user?.id]);

  useEffect(() => {
    fetchSignatures();
  }, [fetchSignatures]);

  useEffect(() => {
    if (savedSignatures?.length > 0 && !selectedSignatureId) {
      const defaultSig = savedSignatures.find(s => s.is_default === 1);
      if (defaultSig) {
        handleSignatureSelect(defaultSig.id);
      }
    }
  }, [savedSignatures, selectedSignatureId]);

  const handleSignatureSelect = (id) => {
    if (id === "add_new") {
      setOpenSignatureDialog(true);
      setSelectedSignatureId("");
      return;
    }
    setSelectedSignatureId(id);
    if (id === "") return;
    const sig = savedSignatures.find(s => s.id === id);
    if (sig) {
      setFormData(prev => {
        const updated = {
          ...prev,
          selectedSignatureHtml: sig.signature_html
        };
        step3EmailDataHandler(updated);
        return updated;
      });
    } else {
      setFormData(prev => {
        const updated = {
          ...prev,
          selectedSignatureHtml: ""
        };
        step3EmailDataHandler(updated);
        return updated;
      });
    }
  };

  const handlePreviewSignature = () => {
    const sig = savedSignatures.find(s => s.id === selectedSignatureId);
    if (sig) {
      setPreviewHtml(sig.signature_html);
      setOpenPreviewDialog(true);
    }
  };

  const handleSaveSignature = async () => {
    if (!signatureName.trim() || !signatureHtml.trim() || signatureHtml === "<p><br></p>") {
      setToastMessage("Please provide both name and signature content");
      setOpenSuccessToast(true);
      return;
    }

    setIsSavingSignature(true);
    try {
      const response = await axios.post(`${Key.domain}/user/emp-save-signature`, {
        user_id: user?.id,
        signature_html: signatureHtml,
        signature_name: signatureName,
      });

      if (response.data.success === 1 || response.data.success === true) {
        setToastMessage(response.data.data?.message || "Signature saved successfully");
        setOpenSuccessToast(true);
        setOpenSignatureDialog(false);
        setSignatureName("");
        setSignatureHtml("");
        fetchSignatures(); // Refresh the list after saving
      } else {
        setToastMessage(response.data.message || response.data.data?.message || "Failed to save signature");
        setOpenSuccessToast(true);
      }
    } catch (error) {
      console.error("Error saving signature:", error);
      setToastMessage("Something went wrong");
      setOpenSuccessToast(true);
    } finally {
      setIsSavingSignature(false);
    }
  };


  const documentRows = candidateDocuments.map((doc, index) => ({
    id: index + 1,
    name: doc.name,
    // type: doc.type,
    size: doc.size,
    created: new Date(doc.created).toLocaleString(),
  }));

  return (
    <Grid
      container
      spacing={1}
      sx={{
        p: "10px",
        bgcolor: "#fff",
        ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
          padding: "8px 6px",
        },
        ".ql-toolbar.ql-snow": {
          borderTopLeftRadius: "6px",
          borderTopRightRadius: "6px",
        },
        ".ql-container": {
          borderBottomLeftRadius: "6px",
          borderBottomRightRadius: "6px",
          minHeight: "100px",
        },
        // Prevent default blue for active buttons
        ".ql-snow.ql-toolbar button.ql-active, .ql-snow.ql-toolbar .ql-picker-label.ql-active": {
          color: "#406882 !important",
          backgroundColor: "#f0f4f7 !important",
          borderRadius: "4px",
        },
        ".ql-snow.ql-toolbar button.ql-active .ql-stroke, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke": {
          stroke: "#406882 !important",
        },
        ".ql-snow.ql-toolbar button.ql-active .ql-fill, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill": {
          fill: "#406882 !important",
        },
        // EXCEPTION: Allow the color-indicating part of pickers to show the actual selected color
        ".ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-color-label.ql-stroke, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-background-label.ql-stroke": {
          stroke: "inherit !important",
        },
        // Ensure the color label inherits its color from the dynamic styles Quill generates
        ".ql-snow.ql-toolbar .ql-color.ql-picker.ql-active .ql-picker-label .ql-stroke.ql-color-label": {
          stroke: "currentColor", // This is usually handled by Quill's internal style injection
        }
      }}
    >
      <Grid item xs={12}>
        <FormControl fullWidth>
          {hideToEmail ? (
            <>
              <Typography paragraph sx={labelStyles}>
                CC
              </Typography>
              <TextField
                id="ccEmail"
                variant="outlined"
                placeholder="Enter CC email address (optional)"
                value={formData.ccEmail}
                onChange={handleChange("ccEmail")}
                error={!!errors.ccEmail}
                helperText={
                  errors.ccEmail ||
                  "Vendor email is set per job from the system when sending."
                }
                sx={inputStyles}
              />
            </>
          ) : (
            <>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography paragraph sx={labelStyles}>
                  To
                </Typography>
                <Button onClick={() => setShowCC(!showCC)} size="small">
                  {showCC ? "Hide" : "CC"}
                </Button>
              </Stack>
              <TextField
                id="toEmail"
                variant="outlined"
                placeholder="Enter email address"
                value={formData.toEmail}
                onChange={handleChange("toEmail")}
                error={!!errors.toEmail}
                helperText={errors.toEmail}
                sx={inputStyles}
              />
              {showCC && (
                <>
                  <Typography paragraph sx={labelStyles}>
                    CC
                  </Typography>
                  <TextField
                    id="ccEmail"
                    variant="outlined"
                    placeholder="Enter CC email address"
                    value={formData.ccEmail}
                    onChange={handleChange("ccEmail")}
                    error={!!errors.ccEmail}
                    helperText={errors.ccEmail}
                    sx={inputStyles}
                  />
                </>
              )}
            </>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <Typography paragraph sx={labelStyles}>
            Subject
          </Typography>
          <TextField
            id="subject"
            label=""
            variant="outlined"
            placeholder="Enter subject"
            value={formData.subject}
            onChange={handleChange("subject")}
            error={!!errors.subject}
            helperText={errors.subject}
            sx={inputStyles}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
            <Typography paragraph sx={labelStyles}>
              Email Body
            </Typography>
            <ButtonGroup size="small" sx={{ height: '28px' }}>
              <Button
                variant={editMode === "default" ? "contained" : "outlined"}
                onClick={() => handleEditModeChange("default")}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "12px",
                  padding: "4px 10px",
                  backgroundImage: editMode === "default"
                    ? "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)"
                    : "none",
                  border: editMode === "default" ? "none" : "1px solid #ddd",
                  color: editMode === "default" ? "#fff" : "#406882",
                }}
              >
                Default
              </Button>
              <Button
                variant={editMode === "custom" ? "contained" : "outlined"}
                onClick={() => handleEditModeChange("custom")}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "12px",
                  padding: "4px 10px",
                  backgroundImage: editMode === "custom"
                    ? "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)"
                    : "none",
                  border: editMode === "custom" ? "none" : "1px solid #ddd",
                  color: editMode === "custom" ? "#fff" : "#406882",
                }}
              >
                Custom
              </Button>
            </ButtonGroup>
          </Stack>
          <ReactQuill
            value={formData.emailBody}
            onChange={handleQuillChange}
            readOnly={editMode === "default"}
            placeholder="Enter your message here"
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["code-block"],
                // ["image", "video"],
                ["clean"],
              ],
            }}
          />
          {/* Attachment Button and Input */}
          <Box mt={2}>
            <Button
              variant="outlined"
              component="label"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Add Attachment
              <input
                type="file"
                hidden
                onChange={(e) => {
                  const file = e.target.files && e.target.files[0];
                  if (file) {
                    setFormData((prev) => ({ ...prev, attachmentFile: file }));
                    step3EmailDataHandler((prev) => ({ ...prev, attachmentFile: file }));
                  }
                }}
              />
            </Button>
            {savedSignatures.length > 0 ? (
              <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <FormControl size="small" sx={{ minWidth: 150, ml: 1 }}>
                  <InputLabel id="signature-select-label" sx={{ fontSize: '12px' }}>Apply Signature</InputLabel>
                  <Select
                    labelId="signature-select-label"
                    id="signature-select"
                    value={selectedSignatureId}
                    label="Apply Signature"
                    onChange={(e) => handleSignatureSelect(e.target.value)}
                    sx={{ height: '31px', fontSize: '12px' }}
                  >
                    <MenuItem value="" sx={{ fontSize: '12px' }}><em>None</em></MenuItem>
                    {savedSignatures.map((sig) => (
                      <MenuItem key={sig.id} value={sig.id} sx={{ fontSize: '12px' }}>
                        {sig.signature_name}
                      </MenuItem>
                    ))}
                    <MenuItem value="add_new" sx={{ fontSize: '12px', color: '#1e88e5', fontWeight: 600 }}>
                      + Add New
                    </MenuItem>
                  </Select>
                </FormControl>
                <Tooltip title="Preview selected signature">
                  <IconButton
                    size="small"
                    onClick={handlePreviewSignature}
                    disabled={!selectedSignatureId}
                    sx={{ ml: 0.5, color: '#1e88e5' }}
                  >
                    <Visibility fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            ) : (
              <Button
                variant="outlined"
                size="small"
                onClick={() => setOpenSignatureDialog(true)}
                sx={{ textTransform: "none", ml: 1 }}
              >
                Add Signature
              </Button>
            )}
            {formData.attachmentFile ? (
              <Box sx={{ display: 'inline-flex', alignItems: 'center', ml: 2 }}>
                <Typography variant="body2" sx={{ display: "inline" }}>
                  {formData.attachmentFile.name}
                </Typography>
                <IconButton
                  size="small"
                  aria-label="Remove attachment"
                  onClick={() => {
                    setFormData((prev) => ({ ...prev, attachmentFile: undefined }));
                    step3EmailDataHandler((prev) => ({ ...prev, attachmentFile: undefined }));
                  }}
                  sx={{ ml: 1 }}
                >
                  <span style={{ fontSize: 18, fontWeight: 'bold', lineHeight: 1 }}>&times;</span>
                </IconButton>
              </Box>
            ) : null}
          </Box>
        </FormControl>
      </Grid>
      {resumes && resumes.length > 0 && (
        <Grid
          item
          xs={12}
        // sx={{
        //   display: resumes && resumes.length > 0 ? "none" : "block",
        // }}
        >
          <Typography paragraph sx={labelStyles}>
            Select Resume
          </Typography>
          <Grid container spacing={0.5}>
            {resumes.filter(resume => resume.resume_id === selectedId).map((resume, index) => (
              <Grid item sm={12} key={index}>
                <Card
                  sx={{
                    boxShadow: "none",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Radio
                    {...controlProps(resume)}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 20,
                      },
                    }}
                  />
                  <img src={pdfImg} width={26} height={26} alt="PDF" />
                  <Tooltip followCursor title={resume.application_title}>
                    <Typography
                      paragraph
                      sx={{
                        mb: 0,
                        fontWeight: 500,
                        fontSize: "14px",
                        minWidth: isDesktopLarge ? "auto" : "90px",
                        maxWidth: isDesktopLarge ? "auto" : "90px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {resume.filename.trim().normalize("NFC").replace(/^(CAND_)+/gi, "")}
                    </Typography>
                  </Tooltip>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
      {candidateDocuments.length > 0 && (
        <Grid item xs={12}>
          <Typography paragraph sx={labelStyles}>
            Select Documents
          </Typography>
          <Box sx={{ height: "auto", width: "100%" }}>
            <DataGrid
              rows={documentRows}
              columns={columns}
              pageSize={5}
              checkboxSelection
              disableSelectionOnClick
              pageSizeOptions={5}
              onSelectionModelChange={(selection) => {
                new Promise((resolve) =>
                  setTimeout(() => resolve(selection), 1000)
                ).then((selection) => { });
              }}
            />
          </Box>
        </Grid>
      )}

      <Dialog
        open={openPreviewDialog}
        onClose={() => setOpenPreviewDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Signature Preview</DialogTitle>
        <DialogContent dividers sx={{ overflow: "auto", maxHeight: "75vh" }}>
          <Box
            dangerouslySetInnerHTML={{ __html: previewHtml }}
            sx={{
              p: 2,
              border: "1px solid #eee",
              borderRadius: "4px",
              minHeight: "100px",
              bgcolor: "#fcfcfc",
              overflowX: "auto",
              overflowY: "visible",
              width: "100%",
              "& table": {
                borderCollapse: "collapse",
                maxWidth: "none",
              },
              "& img": {
                maxWidth: "none",
                height: "auto",
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPreviewDialog(false)} sx={{ textTransform: 'none' }}>Close</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSuccessToast}
        autoHideDuration={6000}
        onClose={handleSuccessToastClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={handleSuccessToastClose}
          severity={
            toastMessage === "Something went wrong" ? "error" : "success"
          }
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
        open={openSignatureDialog}
        onClose={() => !isSavingSignature && setOpenSignatureDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Create Email Signature</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Signature Name
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="e.g., Official Signature"
              value={signatureName}
              onChange={(e) => setSignatureName(e.target.value)}
            />
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Signature Content
            </Typography>
            <SignatureEditor
              value={signatureHtml}
              onChange={setSignatureHtml}
              height={300}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setOpenSignatureDialog(false)}
            disabled={isSavingSignature}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSaveSignature}
            disabled={isSavingSignature}
            sx={{
              textTransform: "none",
              backgroundImage: "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
            }}
          >
            {isSavingSignature ? <CircularProgress size={24} color="inherit" /> : "Save Signature"}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default Step3;

const labelStyles = {
  color: "rgb(160, 171, 184)",
  marginBottom: "5px",
};

const inputStyles = {
  border: "1px solid  rgb(224, 230, 247)",
  borderRadius: "4px",
  "&:hover": {
    border: "1px solid  rgb(224, 230, 247)",
    borderRadius: "4px",
  },
};
